
 /**
   * prevent body Touch event in Touch devices when Overlay is visible
   *
   * @param {event} event - event instance
 */
 function bodyTouchMove(event){
   let currentTarget = event.target;
   if (!currentTarget.closest('[data-touch-moveable]')) {
     event.preventDefault();
     return false;
   }
 }

 /**
   * Fetch call config
   *
   * @param {string} type - request Accept type
 */
 function fetchConfig(type = 'json') {
   return {
     method: 'POST',
     headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
   };
 }

 /**
   * Dropdown component Events and Methods
   *
   * @param {element} element - Dropdown element
   */
  function dropDownInit(element){

   let dropdownParent = element.parentElement;
   const _this = element;

   ["mouseover", "focusin",  "click", "touchend", "mouseout"].forEach(function(type){
     if(type == 'click' || type == 'touchend'){
       dropdownParent.addEventListener(type, (e) => {
         e.stopPropagation();
         let currentTarget = e.currentTarget;
         dropdownToggle(dropdownParent);
       });
     }else if(type == 'mouseout'){
       dropdownParent.addEventListener(type, (e) => {
         let currentTarget = e.currentTarget;
         if(!currentTarget.closest('[data-touch-moveable]')){
           e.stopPropagation();
           dropdownHide(dropdownParent, e);
         }
       });
     } else if(type == 'mouseover' || type == 'focusin'){
       dropdownParent.addEventListener(type, (e) => {
         let currentTarget = e.currentTarget;
         if(!currentTarget.closest('[data-touch-moveable]')){
           dropdownShow(dropdownParent);
         }
       });
       _this.addEventListener(type, (e) => { ChildonFocusChange(dropdownParent); });
     }
   });

   dropdownParent.addEventListener('keyup', (event) => {
     if (event.code.toUpperCase() === 'ESCAPE'){ dropdownHide(event.currentTarget); }
     if (event.code.toUpperCase() === 'ENTER'){ dropdownShow(event.currentTarget); }
   });

   function dropdownToggle(dropdownParent) {
     let isActive = dropdownParent.classList.contains('open');
     setTimeout(function(){
       if(!isActive){ dropdownShow(dropdownParent); }
       else if(isActive){ dropdownHide(dropdownParent); }
     }, 50);
   }

   function dropdownShow(dropdownParent){
     _this.setAttribute('aria-expanded', true);
     if(!dropdownParent.closest('[data-role="drawer"]')){
       dropdownParent.classList.add('open');
     }else{
       Utility.toggleElement(dropdownParent, 'open');
     }
   }

   function dropdownHide(dropdownParent, evt){
     _this.setAttribute('aria-expanded', false);
     if(!dropdownParent){
       return;
     }

     if(!dropdownParent.closest('[data-role="drawer"]')){
       dropdownParent.classList.remove('open');
     }else{
       Utility.toggleElement(dropdownParent, 'close');
     }
     if(evt && evt.type == 'mouseout' && dropdownParent.parentElement.closest('.dropdown')){
       dropdownParent.parentElement.closest('.dropdown').classList.remove('open');
     }

     let childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
     if(childDropdowns.length > 0){
       childDropdowns.forEach(function(child){
         child.classList.remove('open');
         var toggleLink = child.querySelector('a[data-toggle="open"]');
         if(toggleLink) toggleLink.setAttribute('aria-expanded', false);
       });
     }
   }

   function ChildonFocusChange(dropdownParent){
     let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
     let currentIndex = openDropdowns.indexOf(dropdownParent);
     openDropdowns.forEach(function(ele, eleIndex){
       if(eleIndex != currentIndex){ dropdownHide(ele); }
     });
   }
 }

 const allDropdowns = document.querySelectorAll('a[is="drop-down"]');
 allDropdowns.forEach(function(ele) {
   dropDownInit(ele)
 });

 /**
  * Close SubMenu Dropdowns on Regular Nav Item fous or click
  *
  * @param {element} element - Dropdown element
  */
 function defaultNavItem(element){
   let _this = element;
   ["focusin", "click", "mouseover", "mouseout"].forEach(function(type){
     _this.addEventListener(type, (e) => {
       let currentTarget = e.currentTarget;
       if(!currentTarget.closest('[data-touch-moveable]')){
         hideDropdown(_this.parentElement);
       }
     });
   });

   ["click", "touchend"].forEach(function(type){
     _this.addEventListener(type, (e) => {
       e.stopPropagation();
     });
   });

   function hideDropdown(dropdownParent){
     let openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
     openDropdowns.forEach((ele) => {
       ele.classList.remove('open');
       ele.querySelector('[is="drop-down"]').setAttribute('aria-expanded', false);
     });
   }
 }

 const allDefaultNav = document.querySelectorAll('a[is="simple-menu-item"]');
 allDefaultNav.forEach(function(ele) {
   defaultNavItem(ele);
 });

 Utility.manageAnimationClass();

 /**
 * Website Overlay for Mobile Menu and Cart Drawer
 */
 class siteOverlay extends HTMLElement{
   constructor() {
     super();

     this.menuDrawer = document.querySelector('#mobile-menu-drawer');
     this.cartDrawer = document.querySelector('ajax-cart.cart-drawer');
     this.bindEvents();
   }

   /**
    * bind Click and Touchend event to this custom component
    */
   bindEvents(){
     this.addEventListener('click', this.onClick.bind(this));
     this.addEventListener('touchend', this.onClick.bind(this));
   }

   /**
    * Click event of Site overlay
    * @param {event} Event instance performed
    */
   onClick(event){
     if(this.cartDrawer && this.cartDrawer.classList.contains('opened-drawer')){
       document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
     }
     if(this.menuDrawer && this.menuDrawer.classList.contains('opened-drawer')){
       document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
     }
     this.hideOverlay();
   }

   /**
    * Show Overlay
    */
   showOverlay(){
      document.querySelector('#chat-button').classList.add('d-none');
     document.getElementById('site-overlay').classList.add('overlay--body');
     document.body.style.overflowY = "hidden";
     document.body.addEventListener('touchmove', bodyTouchMove, false);
   }

   /**
    * Hide overlay
    */
   hideOverlay(){
      document.querySelector('#chat-button').classList.remove('d-none');
     document.getElementById('site-overlay').classList.remove('overlay--body');
     document.body.style.overflowY = "auto";
     document.body.removeEventListener('touchmove', bodyTouchMove, false);
   }
 }
 customElements.define("site-overlay", siteOverlay);

 /**
 * Mobile Navigation Drawer
 */
 class MobileNavigation extends HTMLElement {
   constructor() {
     super();

     this.touchstartX = 0;
     this.touchendX = 0;

     this.openeBy = document.querySelector('#mobile-menu');
     this.closeBy = this.querySelector('.close-mobile--navbar');
     this.navDrawer = this.querySelector('#mobile-menu-drawer');
     this.bindEvents();
   }

   /**
    * Focus Out Event to close drawer
    *
    * @param {event} Event instance
    */
   focusOut(event){
     let isOpen = this.navDrawer.classList.contains('opened-drawer');
     if (!this.contains(event.relatedTarget) && isOpen == true) {
       this.closeBy.dispatchEvent(new Event('click'));
     }
   }

   /**
    * Escape Key Press to close drawer when focus is within the container
    *
    * @param {event} Event instance
    */
   onKeyUp(event) {
     if(event.code.toUpperCase() !== 'ESCAPE') return;
     this.closeBy.dispatchEvent(new Event('click'));
   }

   /**
    * bind click event to Menu Icon
    * bind keyup event to Menu Drawer component
    */
   bindEvents() {
     this.openeBy.addEventListener('click', this.openMenuDrawer.bind(this));
     this.closeBy.addEventListener('click', this.closeMenuDrawer.bind(this));
     this.addEventListener('keyup', this.onKeyUp.bind(this));
     // this.openeBy.addEventListener('focusout', this.focusOut.bind(this));
   }

   /**
    * Open Menu Drawer
    *
    * @param {event} Event instance
    */
   openMenuDrawer(event) {
     this.navDrawer.classList.add('opened-drawer');
     siteOverlay.prototype.showOverlay();
     var cartDrawer = document.querySelector('ajax-cart.cart-drawer');
     if(cartDrawer && cartDrawer.classList.contains('opened-drawer')){
       var closeCart = document.querySelector('.close-ajax--cart');
       if(closeCart) closeCart.dispatchEvent(new Event('click'));
     }
     if(event){
       event.preventDefault();
       let openBy = event.currentTarget;
       openBy.setAttribute('aria-expanded', true);
     }
   }

   /**
    * Close Menu Drawer
    *
    * @param {event} Event instance
    */
   closeMenuDrawer(event, elementToFocus = false) {
     if (event !== undefined) {
       event.preventDefault();
       this.navDrawer.classList.remove('opened-drawer');
       siteOverlay.prototype.hideOverlay();
       this.openeBy.setAttribute('aria-expanded', false);
       Utility.forceFocus(this.openeBy);
     }
   }

   /**
    * To get User Touch action pattern (Swipe Left / Swipe Right)
    *
    */
   handleGesture() {
     if (this.touchendX < this.thistouchstartX)
       this.openeBy.dispatchEvent(new Event('click'));
     if (this.touchendX > this.touchstartX)
       this.closeBy.dispatchEvent(new Event('click'));
   }
 }
 customElements.define("mobile-nav", MobileNavigation);

   /**
  * Slider Component
  *
  */
  let productSlider = null;
  class sliderElement extends HTMLElement {
    constructor() {
        super();
        this.sliderEle = this.querySelector('.swiper-slider');
    }

    connectedCallback() {
        if (!this.sliderEle) return;

        let sliderOptions = this.sliderEle.getAttribute('data-slider');
        sliderOptions = JSON.parse(sliderOptions);

        // Set up nav slider 
        if (this.sliderEle.hasAttribute('data-nav')) {
            let thumbSlider = document.querySelector('.' + this.sliderEle.getAttribute('data-nav'));
            if (!thumbSlider) {
                return;
            }
            let thumbSliderOptions = thumbSlider.getAttribute('data-slider');
            thumbSliderOptions = JSON.parse(thumbSliderOptions);
            thumbSlider = new Swiper(thumbSlider, thumbSliderOptions);

            sliderOptions.thumbs = {
                swiper: thumbSlider
            }
        }

        let sliderInstance = new Swiper(this.sliderEle, sliderOptions);
        if (this.sliderEle.classList.contains('pdp-carousel')) {
            productSlider = sliderInstance;
            this.setupFullscreen(sliderInstance);
        } else if (this.sliderEle.classList.contains('quickshop-slider')) {
            quickShopSlider = sliderInstance;
        }

        this.slideChangeEvt(sliderInstance);
    }

    slideChangeEvt(slider) {
        slider.on('slideChange', (event) => {
            const currentTarget = event.el;
            const customActiveVideo = currentTarget.querySelectorAll('custom-video.show--video');
            if (customActiveVideo.length === 0) return;
            customActiveVideo.forEach((video) => {
                let videoType = video.getAttribute('data-video-type');
                let videoEle = video.querySelector('video') || video.querySelector('iframe');
                if (!videoEle) return;
                if (videoType == 'local') {
                    videoEle.pause();
                } else if (videoType == 'youtube') {
                    videoEle.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else {
                    video.toggleView();
                }
            });
        });
    }

    setupFullscreen(slider) {
        var arrow_open_button = document.querySelector('.pdp-carousel [data-open-fullscreen-button]');
        arrow_open_button.addEventListener('click', () => {
            let slider_index = document.getElementsByClassName("swiper-slide-active")[0].getAttribute("data-slider-index");
            this.openFullscreenSwiper(slider, parseInt(slider_index) - 1);
        });

        var arrow_close_button = document.querySelector('.pdp-carousel [data-close-fullscreen-button]');
        arrow_close_button.addEventListener('click', () => {
            let slider_index = document.getElementsByClassName("swiper-slide-active")[0].getAttribute("data-slider-index");
            this.closeFullscreenSwiper(slider, parseInt(slider_index) - 1);
        });
    }

    openFullscreenSwiper(slider, slideNumber) {
        document.body.style.overflowY = "hidden";
        slider.el.classList.add('fullscreen');
        slider.params.slidesPerView = 1;
        slider.update();
        slider.slideToLoop(parseInt(slideNumber, 10), 0);
    }

    closeFullscreenSwiper(slider, slideNumber) {
        document.body.style.overflowY = "auto";
        slider.el.classList.remove('fullscreen');
        slider.params.slidesPerView = 1;
        slider.update();
        slider.slideToLoop(parseInt(slideNumber, 10), 0);
    }
}

customElements.define('slider-element', sliderElement);


  /**
  * Accordion HTML
  */
   class customAccordion extends HTMLElement {
    constructor() {
      super();

      this.accordionType = this.dataset.accordiontype;
      this.toggleBtns = this.querySelectorAll('.accordion__Toggle');
      this.toggleBtns.forEach(button => button.addEventListener('click', this.toggleAccordionBlock.bind(this)));
    }

    /**
     * Focus Out Event to close drawer
     *
     * @param {event} Event instance
     */
    focusOut(event){

    }

    /**
     * Escape Key Press to close drawer when focus is within the container
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
    }

    /**
     * Toggle Tabs on link click
     *
     * @param {event} Event instance
     */
     toggleAccordionBlock(event){
      event.preventDefault();
      const toggleBtn = event.currentTarget;
      const targetContainer = toggleBtn.parentNode;
      const isOpen = targetContainer.classList.contains('open');
      isOpen ? this.closeAccordionBlock(toggleBtn) : this.openAccordionBlock(toggleBtn);
    }

    /**
     * Open Tab Container
     *
     * @param {Node} toggleBtn Accordion Block Open link
     */
     openAccordionBlock(toggleBtn) {
      let targetContainer = toggleBtn.parentNode;
      toggleBtn.setAttribute('aria-expanded', true);
      Utility.toggleElement(targetContainer, 'open');
      if(this.accordionType == 'single'){
        let siblingBlocks = targetContainer.parentNode.querySelectorAll('.accordion__container');
        siblingBlocks.forEach(element => {
          if(element == targetContainer){ return; }
          element.classList.remove('open');
          element.querySelector('.accordion__block').classList.remove('open');
          element.querySelector('.accordion__Toggle').setAttribute('aria-expanded', false);
        });
      }
      Utility.trapFocus(targetContainer);
    }

    /**
     * Close Tab Container
     *
     * @param {Node} currentTab Tab Container link
     * @param {Node} tabContainer Tab Container to close
     */
     closeAccordionBlock(toggleFilterBtn) {
      const targetContainer = toggleFilterBtn.parentNode;
      toggleFilterBtn.setAttribute('aria-expanded', false);
      Utility.toggleElement(targetContainer, 'close');
      Utility.removeTrapFocus(targetContainer);
    }
  }
  customElements.define("custom-accordion", customAccordion);

  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.modal = this.querySelector('.modal');
      this.modalOpener = document.querySelector('[data-modal-opener="'+this.id+'"]');
      if(this.modalOpener) this.modalOpener.addEventListener('click', ()=>{
        this.show(this.modalOpener);
      });

      if(this.querySelector('[id^="ModalClose-"]')){
        this.querySelector('[id^="ModalClose-"]').addEventListener(
          'click',
          this.hide.bind(this)
        );
      }

      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });

    }

    show(opener) {
      this.openedBy = opener;
      this.modal.classList.add('open');
      siteOverlay.prototype.showOverlay();
      Utility.trapFocus(this);
      Utility.forceFocus(this.querySelector('[id^="ModalClose-"]'));
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.modal.classList.remove('open');
      siteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);

      if(this.id == 'PopupModal-video' && document.getElementsByTagName('custom-video')){
        this.querySelector('.video-section').innerHTML = '';
        document.querySelector('custom-video').classList.remove('show--video');
      }
    }
  }
  customElements.define('modal-dialog', ModalDialog);

  // Start Klaviyo Email Preferences
  window.addEventListener("klaviyoForms", function(e) {

    if (e.detail.type == 'submit') {
      let exdays = 30;
      let cname = 'klaviyo_email';
      let cvalue = document.querySelector(".kl-private-reset-css-Xuajs1 input[name='email']").value;
      Utility.setCookie(cname, cvalue, exdays);
    }

    if(e.detail.type == 'redirectedToUrl'){
      let numberValue = document.querySelector(".kl-private-reset-css-Xuajs1 input[name='phone-number']").value;
      let exdays = 30;
      let phoneNumberName = 'klaviyo_PhoneNumber';
      Utility.setCookie(phoneNumberName, numberValue, exdays);
    }

  });

  // Hide Gorgias app icon
  var gorgiasChatInterval = window.setInterval(function() {

  let gorgiasChat = document.querySelector("#chat-button");
  let smileLauncher = document.querySelector(".smile-launcher-frame-container");

    if(gorgiasChat && smileLauncher){
      if (window.GorgiasChat && GorgiasChat.hasOwnProperty("on")) {
        window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.
        // the list of supported events is detailed below
        var elem = document.body.querySelector('.smile-launcher-frame-container');
        try{

          GorgiasChat.on('widget:opened', function(data) {
            // your code should go here
            elem.style.display = 'none';
          });
          
          GorgiasChat.on('widget:closed', function(data) {
            // your code should go here
            elem.style.display = 'block';
          });
        }catch(error){
          Rollbar.error('gorgias widget error',error)
        }
    }
  }

  },100);


/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @return {String} value - formatted value
 */

 Shopify.formatMoney = function(cents, format){
  if (format == null || format == undefined){
    format = window.globalVariables.money_format || "${{amount}}";
  }
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {

    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) { return 0; }
    number = (number/100.0).toFixed(precision);
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

/**
   * Manage Custom Notification Trigger
   *
   */
 class Notification extends HTMLElement {
  constructor() {
    super();

    this.paused = false;
    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');

    this.container.addEventListener('mouseover', (event) =>{
      this.paused = true;
    });
    this.container.addEventListener('mouseout', (event) =>{
      this.paused = false;
    });

    if(this.closeBtn){
      this.closeBtn.addEventListener('click', (e)=> {
        e.preventDefault();
        this.container.classList.remove('open');
        this.querySelector('.snotifyToast__title').innerHTML = '';
        this.querySelector('.snotifyToast__body').innerHTML = '';
        this.container.classList.remove('snotify-warning,snotify-info,snotify-error,snotify-success');
        this.querySelector('[data-toast-pr]').removeAttribute('style');
      });
    }
  }

  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').innerHTML = title;
    this.querySelector('.snotifyToast__body').innerHTML = body;

    if(options.type == 'error'){
      this.container.classList.add('snotify-error');
    }else if(options.type == 'warning'){
      this.container.classList.add('snotify-warning');
    }else if(options.type == 'info'){
      this.container.classList.add('snotify-info');
    }else if(options.type == 'success'){
      this.container.classList.add('snotify-success');
    }

    this.container.classList.add('open');
    this.manageToggle(options.timeout)
  }

  manageToggle(timeout){
    this.progressBar = this.querySelector('[data-toast-pr]');
    let unit = parseInt(timeout) / 1000;
    unit = 100 / unit;
    let width = 0;

    let interval = setInterval(() => {
      if(this.paused == false){
        width += unit;
        this.progressBar.setAttribute('style', `width: ${width}%`);
        if (width > 100) {
          this.closeBtn.dispatchEvent(new Event('click'));
          clearInterval(interval);
        }
      }
    }, 1000)
  }
}
customElements.define("custom-notification", Notification);

(function showEmailPreferencesSuccessToast() {
  try {
    if (sessionStorage.getItem('email_preferences_success') !== '1') return;
    sessionStorage.removeItem('email_preferences_success');
    var notificationEle = document.querySelector('custom-notification');
    if (notificationEle) {
      notificationEle.updateNotification(
        'The form has been submitted successfully.',
        'Email Preferences',
        { type: 'success', timeout: 5000 }
      );
    }
  } catch (e) {}
})();

/***
 *
 * Read more / read less (single delegated listener)
 */
document.addEventListener('click', function (event) {
  var t = event.target;
  if (t.closest && (t.closest('[data-btn-readmore]') || t.closest('[data-btn-readless]'))) {
    var content_div = document.querySelector('[data-content]');
    var read_more_btn = document.querySelector('[data-btn-readmore]');
    var read_less_btn = document.querySelector('[data-btn-readless]');
    if (!content_div || !read_more_btn || !read_less_btn) return;
    if (t.closest('[data-btn-readmore]')) {
      content_div.classList.replace('readLess_btn', 'readMore_btn');
      read_more_btn.classList.replace('d-block', 'd-none');
      read_less_btn.classList.remove('d-none', 'd-block');
    } else if (t.closest('[data-btn-readless]')) {
      content_div.classList.replace('readMore_btn', 'readLess_btn');
      read_more_btn.classList.replace('d-none', 'd-block');
      read_less_btn.classList.remove('d-block', 'd-none');
    }
    return;
  }
  if (t.classList && t.classList.contains('data-scroll-top')) {
    var targetSection = document.querySelector('[data-product-form]');
    if (targetSection) targetSection.scrollIntoView({ behavior: 'smooth' });
    return;
  }
});